import { ScreenId } from "@/js/value-objects/screen-id";
export class PushNotificationScreenMode {
  // 新規作成
  static CREATE = "push-notification-create";
  // 編集
  static EDIT = "push-notification-edit";
  // 参照
  static VIEW = "push-notification-view";
  // コピーして編集
  static DUPLICATE = "push-notification-duplicate";

  /**
   * コンストラクタ
   * @param {*} value Routerのname属性
   */
  constructor(value) {
    this.value = value;
  }
  /**
   * インスタンス生成
   * @param {*} value Routerのname属性
   * @returns PushNotificationScreenModeインスタンス
   */
  static factory(value) {
    return new PushNotificationScreenMode(value);
  }
  /**
   * モード判定（新規作成）
   * @returns true：「新規作成」モード、false：「新規作成」モード以外
   */
  isCreate() {
    return this.value === PushNotificationScreenMode.CREATE;
  }
  /**
   * モード判定（編集）
   * @returns true：「編集」モード、false：「編集」モード以外
   */
  isEdit() {
    return this.value === PushNotificationScreenMode.EDIT;
  }
  /**
   * モード判定（参照）
   * @returns true：「参照」モード、false：「参照」モード以外
   */
  isView() {
    return this.value === PushNotificationScreenMode.VIEW;
  }
  /**
   * モード判定（コピーして編集）
   * @returns true：「コピーして編集」モード、false：「コピーして編集」モード以外
   */
  isDuplicate() {
    return this.value === PushNotificationScreenMode.DUPLICATE;
  }
  /**
   * 画面ID取得
   * @returns 画面ID
   */
  getScreenId() {
    let screenId = "";
    switch (this.value) {
      case PushNotificationScreenMode.CREATE:
        // 新規登録
        screenId = ScreenId.SF0305;
        break;
      case PushNotificationScreenMode.EDIT:
        // 編集
        screenId = ScreenId.SF0304;
        break;
      case PushNotificationScreenMode.VIEW:
        // 参照
        screenId = ScreenId.SF0303;
        break;
      case PushNotificationScreenMode.DUPLICATE:
        // コピーして編集
        screenId = ScreenId.SF0304;
        break;
      default:
        break;
    }
    return screenId;
  }
}
